// Module
var code = `<div class="alert">
  <span>
    <strong>DISCLAIMER:</strong> This form can be used to push failed ledger sync job.
  </span>
</div>

<h2 class="section-header">Please confirm the following:</h2>
<form name="form">
  <table class="table">
    <tbody>
    <tr>
      <td>Branch:</td>
      <td>
        <select
          ng-model="\$ctrl.branch"
          ng-options="branch as branch.name | prettyEnum for branch in \$ctrl.branches | orderBy:'name'"
          required>
        </select>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="flex-end">
    <button
      type="button"
      class="btn btn-success"
      ng-disabled="form.\$invalid"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/push-failed-ledger-sync/push-failed-ledger-sync.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;